/*
  Fiche produit RésineLab : choix du conditionnement (prix, référence, image, URL),
  galerie (vignettes en desktop, bande à défilement en mobile) et barre collante mobile.
  JavaScript natif.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-rl-product]');
  if (!root) return;

  /* ------------------------------------------------- Choix du conditionnement */

  var cells = Array.prototype.slice.call(root.querySelectorAll('[data-rl-variant]'));
  var input = root.querySelector('[data-rl-variant-input]');
  var priceEl = root.querySelector('[data-rl-price]');
  var priceAltEl = root.querySelector('[data-rl-price-alt]');
  var priceLabelEl = root.querySelector('[data-rl-price-label]');
  var variantTitleEl = root.querySelector('[data-rl-variant-title]');
  var skuEl = root.querySelector('[data-rl-product-sku]');
  var stickyPrice = root.querySelector('[data-rl-sticky-price]');
  var stickyVariant = root.querySelector('[data-rl-sticky-variant]');
  var addButton = root.querySelector('[data-rl-add]');
  var contentEl = root.querySelector('[data-rl-content]');
  var skuPrefix = skuEl ? (skuEl.textContent.trim().split(' ')[0] || '') : '';

  function select(cell) {
    if (!cell) return;

    cells.forEach(function (other) {
      var active = other === cell;
      other.classList.toggle('rl-buy__cell--active', active);
      other.setAttribute('aria-checked', active ? 'true' : 'false');
    });

    var id = cell.getAttribute('data-rl-variant');
    var price = cell.getAttribute('data-price');
    var title = cell.getAttribute('data-title');
    var sku = cell.getAttribute('data-sku');
    var available = cell.getAttribute('data-available') === 'true';
    var mediaIndex = parseInt(cell.getAttribute('data-media'), 10);

    var quote = cell.getAttribute('data-quote') === 'true';

    if (input) input.value = id;
    if (priceEl) {
      priceEl.textContent = price;
      // Format sur devis : montant grisé, mention de TVA retirée (les autres formats gardent la leur)
      priceEl.classList.toggle('rl-buy__amount--quote', quote);
    }
    if (priceAltEl) priceAltEl.textContent = cell.getAttribute('data-price-alt') || '';
    if (priceLabelEl) priceLabelEl.textContent = cell.getAttribute('data-price-label') || '';
    if (variantTitleEl) variantTitleEl.textContent = title;
    if (stickyPrice) stickyPrice.textContent = cell.getAttribute('data-price-main') || price;
    if (stickyVariant) stickyVariant.textContent = title;
    if (contentEl) contentEl.textContent = cell.getAttribute('data-content') || '';
    if (skuEl && sku) skuEl.textContent = (skuPrefix ? skuPrefix + ' ' : '') + sku;

    if (addButton) {
      addButton.disabled = !available;
      addButton.setAttribute('aria-disabled', available ? 'false' : 'true');
    }

    if (!isNaN(mediaIndex) && mediaIndex >= 0) showSlide(mediaIndex);

    // Garde l'URL partageable sans recharger la page.
    var url = new URL(window.location.href);
    url.searchParams.set('variant', id);
    window.history.replaceState({}, '', url);
  }

  cells.forEach(function (cell) {
    cell.addEventListener('click', function () {
      select(cell);
    });
    cell.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      // Avec une seconde option, seuls les formats de la teinte retenue sont affichés
      var visibles = cells.filter(function (c) { return !c.hidden; });
      var next = visibles[visibles.indexOf(cell) + (event.key === 'ArrowRight' ? 1 : -1)];
      if (next) {
        next.focus();
        select(next);
      }
    });
  });

  /* --------------- Première option (teinte, finition) : filtre les formats */

  var option1 = root.querySelector('[data-rl-option1]');
  if (option1) {
    option1.addEventListener('change', function () {
      var visibles = [];
      cells.forEach(function (cell) {
        var garde = cell.getAttribute('data-option1') === option1.value;
        cell.hidden = !garde;
        if (garde) visibles.push(cell);
      });
      var cible = visibles.filter(function (c) { return c.getAttribute('data-available') === 'true'; })[0] || visibles[0];
      if (cible) select(cible);
    });
  }

  /* ------------------------------------------------------------- Galerie */

  var gallery = root.querySelector('[data-rl-gallery]');
  var viewport = gallery ? gallery.querySelector('[data-rl-gallery-viewport]') : null;
  var slides = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-rl-gallery-slide]')) : [];
  var thumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-rl-gallery-thumb]')) : [];
  var dots = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-rl-gallery-dot]')) : [];

  function isScrollMode() {
    return viewport && window.getComputedStyle(viewport).overflowX !== 'hidden' && viewport.scrollWidth > viewport.clientWidth + 1;
  }

  function markActive(index) {
    slides.forEach(function (slide, i) {
      slide.setAttribute('data-active', i === index ? 'true' : 'false');
    });
    thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle('rl-gallery__thumb--active', i === index);
    });
    dots.forEach(function (dot, i) {
      dot.setAttribute('data-active', i === index ? 'true' : 'false');
    });
  }

  function showSlide(index) {
    if (!slides.length || index >= slides.length) return;
    if (isScrollMode()) {
      viewport.scrollTo({ left: slides[index].offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
    }
    markActive(index);
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showSlide(parseInt(thumb.getAttribute('data-rl-gallery-thumb'), 10));
    });
  });

  if (viewport) {
    var scrollTimer = null;
    viewport.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        if (!isScrollMode()) return;
        var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
        // En mode défilement, toutes les diapositives restent visibles : on ne
        // met à jour que les pastilles et les vignettes.
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('rl-gallery__thumb--active', i === index);
        });
        dots.forEach(function (dot, i) {
          dot.setAttribute('data-active', i === index ? 'true' : 'false');
        });
      }, 80);
    });
  }

  // Bande mobile : la photo du format choisi (pas forcément la première) est montrée au chargement.
  if (viewport) {
    var startIndex = slides.indexOf(viewport.querySelector('[data-rl-gallery-slide][data-active="true"]'));
    if (startIndex > 0 && isScrollMode()) viewport.scrollLeft = slides[startIndex].offsetLeft - viewport.offsetLeft;
  }

  /* --------------------------------------------------- Barre collante mobile */

  var stickyAdd = root.querySelector('[data-rl-sticky-add]');
  var form = root.querySelector('[data-rl-quote-form]');

  // La barre n'est qu'un rappel : elle paraît une fois le formulaire d'achat dépassé
  // (au-dessus de l'écran) et disparaît quand on remonte jusqu'à lui.
  var sticky = root.querySelector('[data-rl-sticky]');
  if (sticky && form) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.setAttribute('data-visible', passed ? 'true' : 'false');
      }).observe(form);
    } else {
      sticky.setAttribute('data-visible', 'true');
    }
  }
  if (stickyAdd && form) {
    stickyAdd.addEventListener('click', function () {
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }

  /* ------------------------------- Variante demandée dans l'URL au chargement */

  var requested = new URLSearchParams(window.location.search).get('variant');
  if (requested) {
    var match = cells.filter(function (cell) {
      return cell.getAttribute('data-rl-variant') === requested;
    })[0];
    if (match) select(match);
  }
})();
